
import { createReducer, on } from '@ngrx/store';
import { loadMemberData, loadMemberDataSuccess, loadMemberDataFailure } from '../actions/members.actions';

export interface State {
  memberData: any[];
  loading: boolean;
  error: string | null;
}

export const initialState: State = {
  memberData: [],
  loading: false,
  error: null,
};

export const memberReducer = createReducer(
  initialState,
  on(loadMemberData, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(loadMemberDataSuccess, (state, { memberData }) => {
    console.log({memberData})
    return ({
    ...state,
    loading: false,
    memberData: memberData,
  })}),
  on(loadMemberDataFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
